import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const Faqs = ({ faqs, lang }) => {
    const { t } = useTranslation();

    const [openIndex, setOpenIndex] = useState(null);

    const toggleFaq = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="o-cont-fullw mb-100">
            <div className="container">
                <div className="mb-6">
                    <h2 className="text-center h2">Preguntas frecuentes</h2>
                    <div className="accordion c-accordion">
                        {faqs.map((faq, index) => (
                            <div className="accordion-item" id={`ngb-accordion-item-${faq.id}`} style={{ borderLeft: "none", borderRight: "none" }} key={faq.id}>
                                <div role="heading" className="accordion-header collapsed">
                                    <h3 >
                                        <p>{faq.pregunta[lang]}</p>
                                    </h3>
                                    <button type="button" className="accordion-button collapsed" id={`ngb-accordion-item-${faq.id}-toggle`} aria-controls={`ngb-accordion-item-${faq.id}-collapse`} aria-expanded="false" onClick={() => toggleFaq(faq.id)}>
                                        <span className="visually-hidden">{t("Más información")}</span>
                                    </button>
                                </div>
                                <div role="region" className={`accordion-collapse ${openIndex !== faq.id && 'collapse'}`} id={`ngb-accordion-item-${faq.id}-collapse`} aria-labelledby={`ngb-accordion-item-${faq.id}-toggle`}>
                                    {openIndex === faq.id && (
                                        <div className="accordion-body" dangerouslySetInnerHTML={{ __html: faq.respuesta[lang] }}></div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div >

    );
};

export default Faqs;
